import moment from 'moment';

import { DATE_FORMAT, MIN_DATE } from '@/consts';

import {
  APPLY_FILTERS,
  CLEAR_FILTERS,
  SET_ITEMS,
  RESET,
  SET_TARGETING_CLIENT,
  SET_CLIENTS_DUE_CONTRACTS,
  SET_SUMMARY_INFO,
  SET_CURRENT_COMPONENT,
  SET_LATE_DAYS
} from './types';

export const INIT_STATE = {
  filters: {
    term: '',
    page: 1,
    pageSize: 20,
    minApprovedAmount: null,
    maxApprovedAmount: null,
    branches: [],
    assetTypes: [],
    fromDate: moment(MIN_DATE).format(DATE_FORMAT),
    toDate: moment().format(DATE_FORMAT),
    hasValueAdjustment: false,
    sortedList: ['-due_date_latest', 'mifos_id', 'name', 'total_loans'],
  },
  items: [],
  total: 0,
  loanBalance: 0,
  targetingClient: {
    id: null,
    dueContracts: []
  },
  numberOfPastDueClients: 0,
  numberOfDueContracts: 0,
  numberOfRenewedContracts: 0,
  numberOfRenewedContractsWithCash: 0,
  numberOfRenewedContractsWithBank: 0,
  numberOfAppointments: 0,
  paymentReminderStatus: {
    today: {
      total: 0,
      appointments: 0,
      outOfReach: 0,
      loanBalance: 0,
      totalPrincipalAmount: 0,
      totalInterestAmount: 0,
      totalOverdueAmount: 0,
      totalOutstandingAmount: 0
    },
    late1Day: {
      total: 0,
      appointments: 0,
      outOfReach: 0,
      loanBalance: 0,
      totalPrincipalAmount: 0,
      totalInterestAmount: 0,
      totalOverdueAmount: 0,
      totalOutstandingAmount: 0
    },
    late2To3Days: {
      total: 0,
      appointments: 0,
      outOfReach: 0,
      loanBalance: 0,
      totalPrincipalAmount: 0,
      totalInterestAmount: 0,
      totalOverdueAmount: 0,
      totalOutstandingAmount: 0
    },
    late4To5Days: {
      total: 0,
      appointments: 0,
      outOfReach: 0,
      loanBalance: 0,
      totalPrincipalAmount: 0,
      totalInterestAmount: 0,
      totalOverdueAmount: 0,
      totalOutstandingAmount: 0
    },
    lateOver5Days: {
      total: 0,
      appointments: 0,
      outOfReach: 0,
      loanBalance: 0,
      totalPrincipalAmount: 0,
      totalInterestAmount: 0,
      totalOverdueAmount: 0,
      totalOutstandingAmount: 0
    }
  },
  isCurrentComponent: '',
  lateDays: '',
};

const mutations = {
  [APPLY_FILTERS](state, filters) {
    state.filters = {
      ...state.filters,
      ...filters
    };
  },

  [CLEAR_FILTERS](state) {
    state.filters = { ...INIT_STATE.filters };
  },

  [SET_ITEMS](state, { items, total, loanBalance }) {
    state.items = [...items];
    state.total = total;
    state.loanBalance = loanBalance;
  },

  [RESET](state) {
    Object.keys(INIT_STATE).forEach((key) => {
      if (Object.prototype.hasOwnProperty.call(INIT_STATE, key)) {
        state[key] = INIT_STATE[key];
      }
    });
  },

  [SET_TARGETING_CLIENT](state, client) {
    state.targetingClient = client;
  },

  [SET_CLIENTS_DUE_CONTRACTS](state, dueContracts = []) {
    state.targetingClient = {
      ...state.targetingClient,
      dueContracts
    };
  },

  [SET_SUMMARY_INFO](state, {
    numberOfPastDueClients,
    numberOfDueContracts,
    numberOfRenewedContracts,
    numberOfRenewedContractsWithCash,
    numberOfRenewedContractsWithBank,
    numberOfAppointments,
    paymentReminderStatus

  }) {
    state.numberOfPastDueClients = numberOfPastDueClients;
    state.numberOfDueContracts = numberOfDueContracts;
    state.numberOfRenewedContracts = numberOfRenewedContracts;
    state.numberOfRenewedContractsWithCash = numberOfRenewedContractsWithCash;
    state.numberOfRenewedContractsWithBank = numberOfRenewedContractsWithBank;
    state.numberOfAppointments = numberOfAppointments;
    state.paymentReminderStatus = { ...paymentReminderStatus };
  },

  [SET_CURRENT_COMPONENT](state, component) {
    state.isCurrentComponent = component;
  },

  [SET_LATE_DAYS](state, lateDays) {
    state.lateDays = lateDays;
  }
};

export default mutations;
